// Fallback photo per city for listings without an uploaded photo.
// Delegates to the backend proxy at /api/city-photo/<city>, which fetches the
// Wikipedia representative image for that city and caches it server-side.
// This guarantees the picture actually depicts the city (no random Flickr, no
// food, no maps) and avoids Chrome's ORB block on cross-origin wikimedia.org.

import { BACKEND_URL } from "./api";

export function cityFallbackImage(cityName) {
    if (!cityName) return null;
    const clean = cityName.trim();
    if (!clean) return null;
    return `${BACKEND_URL}/api/city-photo/${encodeURIComponent(clean)}`;
}
